module.exports = __webpack_public_path__ + "static/sharing-screen-5354d9d69fc0b08b1f792c6cbbe37189.jpg";